import styled from '@emotion/styled';

import { focusRing, hoverable, pressable } from '@/shared/design-system';
import { typographyVariantStyles } from '@/shared/design-system/typography-variants';

export const EmailAdviceText = styled('p')(({ theme }) => ({
  margin: 0,
  color: theme.colors.text.secondary,
  ...typographyVariantStyles.body3,
}));

export const EmailAdviceAction = styled('button')(({ theme }) => ({
  display: 'inline',
  padding: 0,
  border: 0,
  backgroundColor: 'transparent',
  color: theme.colors.brand.text,
  cursor: 'pointer',
  ...typographyVariantStyles.body3,
  ...hoverable(theme, 'brandText'),
  ...pressable(theme, 'brandText'),
  ...focusRing(theme, { inset: false }),
  '&:disabled': {
    opacity: 0.5,
    cursor: 'not-allowed',
  },
}));
